/**
 * Superall — React 19 boot.
 *
 * Mirrors the o-mall maybe-init pattern: if VITE_SENTRY_DSN is set at
 * build time, @sentry/react is dynamically imported and initialised.
 * Absent DSN = boots bare with no error or noise.
 *
 * PII redaction is enforced at the SDK boundary via sendDefaultPii: false.
 */
async function maybeInitSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  try {
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      release: import.meta.env.VITE_APP_VERSION ?? 'unknown',
      tracesSampleRate: 0.05,
      sendDefaultPii: false,
      initialScope: { tags: { artifact: 'superall' } },
    });
  } catch {
    /* @sentry/react not installed — continue without it */
  }
}
await maybeInitSentry();

import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Superall: #root element not found in index.html — shell cannot boot.');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
